export default __webpack_public_path__ + "static/media/app-power-dark.0158824c.png";